const RENDER_TYPES = [
  'rating',
  'inline-multiselect',
  'checkbox',
  'radio',
  'select',
]

const resolveRenderProps = (q) => {
  if (RENDER_TYPES.includes(q.fieldType)) return { renderType: q.fieldType }
  if ((q.fieldOptions?.options || []).length) return { renderType: 'select' }
  if (q.fieldType === 'number') return { type: 'number' }
  if (q.fieldType === 'textarea' || q.fieldType === 'rich-text')
    return { as: 'textarea' }
  return {}
}

export const buildCategoryFields = ({
  formConfig,
  category,
  group,
  language,
  sectionValues = {},
  t,
}) => {
  const categoryConfigs = formConfig
    .filter((q) => q.category === category)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  const fields = []

  categoryConfigs.forEach((q) => {
    const label = q.labels?.[language] || q.labels?.['en']

    if (q.fieldType === 'rating') {
      ;(q.fieldOptions?.options || []).forEach((opt) => {
        fields.push({
          name: opt.value,
          label: opt[language] ?? opt['en'],
          renderType: 'rating',
          required: !!opt.is_required,
          width: 12,
          group,
        })
      })
      return
    }

    const options = (q.fieldOptions?.options || []).map((opt) => ({
      label: opt[language] ?? opt['en'],
      value: opt.value,
      explain: !!opt.explain,
    }))

    fields.push({
      name: q.key,
      label,
      required: !!q.isRequired,
      options,
      maxLimit: q.fieldOptions?.maxLimit,
      width: 12,
      group,
      ...resolveRenderProps(q),
    })

    const selectedOption = options.find((o) => o.value === sectionValues[q.key])
    if (selectedOption?.explain) {
      fields.push({
        name: `${q.key}_explanation`,
        label: t('reference.explain'),
        required: true,
        width: 12,
        group,
      })
    }
  })

  return fields
}

export const buildAnswers = ({ formConfig, values }) => {
  const answers = {}
  const categoryConfigs = formConfig
    .filter((q) =>
      ['relationship', 'performance', 'recommendation', 'comments'].includes(
        q.category,
      ),
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  categoryConfigs.forEach((q) => {
    if (q.fieldType === 'rating') {
      const ratingOpts = q.fieldOptions?.options || []
      answers[q.key] = {}
      ratingOpts.forEach((opt) => {
        if (values[opt.value] !== undefined)
          answers[q.key][opt.value] = values[opt.value]
      })
    } else {
      let val = values[q.key]
      const explanationVal = values[`${q.key}_explanation`]
      const selectedOpt = (q.fieldOptions?.options || []).find(
        (o) => o.value === val,
      )
      if (
        selectedOpt?.explain &&
        explanationVal !== undefined &&
        explanationVal !== ''
      ) {
        val = explanationVal
      }
      if (q.fieldType === 'number' && val !== undefined && val !== '') {
        val = Number(val)
      } else if (q.fieldType === 'number' && val === '') {
        val = null
      }
      answers[q.key] = val
    }
  })

  return answers
}

export const computeProgress = (values = {}) => {
  const allValues = Object.values(values)
  const filledCount = allValues.filter(
    (v) =>
      v !== undefined &&
      v !== null &&
      v !== '' &&
      v !== false &&
      !(Array.isArray(v) && v.length === 0),
  ).length
  return allValues.length
    ? Math.round((filledCount / allValues.length) * 100)
    : 0
}
